//API_KEY
export const getApiKey = (): string => {
  const apiKey = localStorage.getItem("api_key");
  if (!apiKey) {
    throw new Error("Missing api_key from localStorage.");
  }
  return apiKey;
};

export const getUserId = (): string | null => localStorage.getItem("user_id");

//TENANT-ID
export const getTenantId = (): string => {
  const tenantId = localStorage.getItem("tenant_id");
  if (!tenantId) {
    throw new Error("Missing tenant_id from localStorage.");
  }
  return tenantId;
};
